<template>
  <modal
    width="35"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
    title="Create Return Shipment"
  >
    <div class="flex flex-col justify-center">
      <div>
        <label class="label">Current Shipment Location:</label>
        <el-select v-model="reason" placeholder="-- Select or Input --">
          <el-option label="Late arrival" value="city.name"> </el-option>
          <el-option label="Damaged package" value="4"> </el-option>
          <el-option label="Rescheduled delivery" value="5"> </el-option>
          <el-option label="Delivery to another address" value="5"> </el-option>
          <el-option label="Others" value="5"> </el-option>
        </el-select>
      </div>
      <div>
        <label class="label">Return Address</label>
        <input type="text" class="input" />
      </div>
      <div>
        <label class="label">Name of Item</label>
        <input type="text" class="input" />
      </div>
      <div>
        <label class="label">Item Description</label>
        <input type="text" class="input" />
      </div>
      <div>
        <label class="label">Weight</label>
        <input type="text" class="input" />
      </div>
      <div>
        <label class="label">Packaging Type</label>
        <input type="text" class="input" />
      </div>
      <div>
        <label class="label">Shipment Cost</label>
        <input type="text" class="input" />
      </div>

      <div class="button-wrapper">
        <div>
          <p class="underline cursor-pointer">Go Back</p>
        </div>
        <div>
          <base-button text="Create" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      reason: "",
    };
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
